import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Shiitake from 'shiitake';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    fontWeight: 'bold',
    fontSize: 'inherit'
    // zIndex: theme.zIndex.appBar - 1
  }
});
interface BreadcrumbLinkProps {
  label: React.ReactChild;
}

const BreadcrumbLink: React.FC<BreadcrumbLinkProps & LinkProps> = ({
  label,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Typography
      noWrap
      className={classes.root}
      component={TypoProps => <Link {...props} {...TypoProps} />}
      color="inherit"
    >
      {/* <Shiitake lines={1} tagName="span"> */}
      {label}
      {/* </Shiitake> */}
    </Typography>
  );
};

export default BreadcrumbLink;
